import React, { useEffect } from "react";
import SignIn from "../Pages/Auth/SignIn";
import {
  Navigate,
  Route,
  Routes,
  useNavigate,
  useLocation,
} from "react-router-dom";
import SignUp from "../Pages/Auth/SignUp";
import ForgotPassword from "../Pages/Auth/ForgotPassword";
import OtpVerify from "../Pages/Auth/OtpVerify";
import Successful from "../Pages/Auth/Successful";
import ResetPassword from "../Pages/Auth/ResetPassword";
import Home from "../Pages/Home/Home";
import Group from "../Pages/Group/Group";
import Channels from "../Pages/Channels/Channels";
import Settings from "../Pages/Settings/Settings";
import SigninWithNumber from "../Pages/Auth/SigninWithNumber";
import OtpVerifyNumber from "../Pages/Auth/OtpVerifyNumber";
import OtpVerifySignup from "../Pages/Auth/OtpVerifySignup";
import SetupProfile from "../Pages/SetupProfile/SetupProfile";
import SuccessProfile from "../Pages/SuccessProfile/SuccessProfile";
import Admin from "../Pages/Admin/Admin";
import Dashboard from "../Pages/Admin/Pages/Dashboard/Dashboard";
import ReportUsers from "../Pages/Admin/Pages/ReportUsers/ReportUsers";
import BlockedUsers from "../Pages/Admin/Pages/BlockedUsers/BlockedUsers";
import User from "../Pages/Admin/Pages/User/User";
import DeletedUsers from "../Pages/Admin/Pages/DeletedUsers/DeletedUsers";
import ProtectedRoute from "./ProtectedRoute";
import { useCookies } from "react-cookie";
import { useSelector } from "react-redux";

const AppRouter = () => {
  const { userInfo } = useSelector((state) => state.authUser);
  const navigate = useNavigate();
  const location = useLocation();
  const [cookies] = useCookies(["accessToken"]);
  const isAuthenticated = !!cookies.accessToken;

  useEffect(() => {
    if (!userInfo.role) return;
    if (location.pathname.startsWith("/admin") && userInfo.role !== "Admin") {
      navigate("/home");
    }
    if (!location.pathname.startsWith("/admin") && userInfo.role === "Admin") {
      navigate("/admin/dashboard");
    }
  }, [location, userInfo]);

  return (
    <Routes>
      <Route
        path="/"
        element={
          isAuthenticated ? (
            <Navigate to="/home" replace />
          ) : (
            <Navigate to="/sign-in" replace />
          )
        }
      />
      <Route
        path="/sign-in"
        element={isAuthenticated ? <Navigate to="/home" replace /> : <SignIn />}
      />
      <Route
        path="/signin-via-number"
        element={
          isAuthenticated ? (
            <Navigate to="/home" replace />
          ) : (
            <SigninWithNumber />
          )
        }
      />
      <Route
        path="/otp-verify-mobile"
        element={
          isAuthenticated ? (
            <Navigate to="/home" replace />
          ) : (
            <OtpVerifyNumber />
          )
        }
      />
      <Route
        path="/sign-up"
        element={isAuthenticated ? <Navigate to="/home" replace /> : <SignUp />}
      />
      <Route
        path="/otp-verify-signup"
        element={
          isAuthenticated ? (
            <Navigate to="/home" replace />
          ) : (
            <OtpVerifySignup />
          )
        }
      />
      <Route
        path="/forgot-password"
        element={
          isAuthenticated ? <Navigate to="/home" replace /> : <ForgotPassword />
        }
      />
      <Route
        path="/otp-verify"
        element={
          isAuthenticated ? <Navigate to="/home" replace /> : <OtpVerify />
        }
      />
      <Route
        path="/reset-password"
        element={
          isAuthenticated ? <Navigate to="/home" replace /> : <ResetPassword />
        }
      />
      <Route
        path="/successful"
        element={
          isAuthenticated ? <Navigate to="/home" replace /> : <Successful />
        }
      />
      <Route
        path="/success-profile"
        element={
          isAuthenticated ? <Navigate to="/home" replace /> : <SuccessProfile />
        }
      />

      <Route path="/sign-in" element={<SignIn />} />
      <Route path="/signin-via-number" element={<SigninWithNumber />} />
      <Route path="/otp-verify-mobile" element={<OtpVerifyNumber />} />
      <Route path="/otp-verify-signup" element={<OtpVerifySignup />} />
      <Route path="/setup-profile" element={<SetupProfile />} />
      <Route path="/success-profile" element={<SuccessProfile />} />

      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/otp-verify" element={<OtpVerify />} />
      <Route path="/successful" element={<Successful />} />

      <Route element={<ProtectedRoute />}>
        <Route path="/home" element={<Home />} />
        <Route path="/groups" element={<Group />} />
        <Route path="/channels" element={<Channels />} />
        <Route path="/channels/:channelSlug" element={<Channels />} />
        <Route path="/settings" element={<Settings />} />
        <Route path="/settings/:type" element={<Settings />} />
        {/* Admin routes with layout */}
        <Route path="/admin" element={<Admin />}>
          {/* Default route when hitting /admin */}
          <Route index element={<Navigate to="dashboard" replace />} />

          {/* Actual admin pages */}
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="userslist" element={<User />} />
          <Route path="deletedusers" element={<DeletedUsers />} />
          <Route path="blockedusers" element={<BlockedUsers />} />
          <Route path="reportusers" element={<ReportUsers />} />
        </Route>
      </Route>
    </Routes>
  );
};

export default AppRouter;
